import HoverCard from './components/index.vue';

HoverCard.install = function(Vue) {
  Vue.component(HoverCard.name, HoverCard)
}

export default HoverCard
